/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_MY_ASSET_DETAIL } from "../pages/MyProductDetail/graphql/get-my-asset-detail.query";
import {REGISTER_MY_WALLET} from "../pages/MyProductDetail/graphql/register-my-wallet.mutation";
import moment from 'moment';
import { transactionDetail } from "./test-data/transaction-reciept";
import { SOUND, VIDEO,PDF_IMAGE } from "../assets/images";
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";
import { SIGN_VOUCHER_MESSAGE } from "./test-data/fiat-purchase-voucher-message";
import { MY_DETAIL,DATA} from "./test-data/product.detail"

const is = require("is_js");

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MyAssetDetailService {
    private static instance: MyAssetDetailService;
    private vapp: VApplication;
    private storeId: any;
    private imageServer: any;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.storeId = props?.storeId;
        this.imageServer = props?.imageServer;
    }
    public static getInstance(props: any = {}): MyAssetDetailService {
        if (!MyAssetDetailService.instance) {
            MyAssetDetailService.instance = new MyAssetDetailService(props);
        }
        return MyAssetDetailService.instance;
    }

    _getImages(data: any, media: any, type: string) {

        const getassetsDetailService = MyAssetDetailService.getInstance();
        const imgUrl = data;
        console.log("sam data:",data ,"type:",type)
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length - 3]

        let _imgF;
        if (ibbFormat === "i.ibb.co") {
            // _imgF = `${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
            _imgF=data

        }
        else {
            // _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            _imgF=data
        }
        let _img;

        if (type === "audio" || type=== "audio/mpeg") {
            _img = {
                original: SOUND,
                thumbnail: SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                embedUrl: data,
            }
        }
        if (type === "video") {
            _img = {
                original: VIDEO,
                thumbnail: VIDEO,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "video",
                embedUrl: data,
            }
        }
        if (type === "image") {
            _img = {
                original: _imgF,
                thumbnail: _imgF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
        }

        if(type === "doc"){
            _img = {
                // original: _imgF,
                // thumbnail: _imgF,
                original:  data?.thumbnail ?? PDF_IMAGE,
                thumbnail: data?.thumbnail ?? PDF_IMAGE,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                pdfUrl:data,
                type: "doc",
            }
         }
             


        let _data = media?.map((item: any) => {
            console.log("insidde", item)
            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length - 3]

            let _imgM;
            if (ibbFormat === "i.ibb.co") {
                _imgF = `${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`

            }
            else {
                _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
            const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
            console.log(`asset Type`, assetType);
            let selectThumbnail;
            if (assetType === "video") {
                selectThumbnail = VIDEO
            } else if (assetType === "audio" || assetType=== "audio/mpeg") {
                selectThumbnail = SOUND
            }else if(assetType === "doc" ){
                selectThumbnail = PDF_IMAGE
             } 
            else {
                // selectThumbnail = _imgM
                selectThumbnail= item?.src
            }





            return {
                // ...item,
                original: selectThumbnail,
                thumbnail: selectThumbnail,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                embedUrl: item?.src,
                type: assetType,
            };
        });
        console.log("IMG_DETAIL", [_img, ..._data])
        let _images = [_img, ..._data];
        
        return _images;
    }

    private _getButtons(priceData: any[], claimEnabled: boolean, state:string, type:string) {
        let buttons: any = []; 
        if(type === "doc"){
            buttons.push(
                {
                    key:"pdfPreview",
                    title:"Preview PDF"
                },
            )
        }    
        if(state ==="sold"){
            buttons.push(
                {
                    key: "transactionDetail",
                    title: "Transaction Receipt"
                },

                {
                    key: "reSell",
                    title: "Resell Item",
                    disabled: false,
                }
            )
        } else
        buttons.push(
            {
                key: "transactionDetail",
                title: "Transaction Receipt"
            },
            {
                key: "reSell",
                title: "Resell Item",
                disabled: true,
                tooltip:"Asset Already Listed"
            }
        )
        return buttons
    }

    private _getOwnershipButtons(resData: any) {
        let _tempButtons: any = [];
        if (resData?.viewInIpfs) {
            _tempButtons.push({
                title: "View on Ipfs",
                link: resData?.viewInIpfs
            })
        }
        if (resData?.getAsset?.hasProvenance) {
            _tempButtons.push({
                title: "Proof of Journey",
                link: resData?.getAsset?.provenanceLink
            })
        }
        return _tempButtons;
    }

    async getAssetDetail(txId: any, signature: any) {
        log.info(`contact address in asset detail`, txId);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("wallet-api");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_ASSET_DETAIL,
                    variables: {
                        input: {
                            tx_id: txId
                        },
                        auth: {
                            signature: signature?.result,
                            message: "Please sign to prove your wallet address",
                            expected_address: signature?.params[1]
                        }
                    },
                });
                log.info(`date in res`, res?.data)
                if (res) {
                    let _data = res?.data?.getMyAsset
                    // let _data = MY_DETAIL?.getMyAsset
                    let _found = {
                        ..._data,
                        tx_id: txId,
                        title: _data?.title,
                        chainId: _data?.chainId,
                        subtitle: _data?.subtitle,
                        serialNo: `Rare #/ ${_data?.serialNo}`,
                        networkType: _data?.networkType,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        price: _data?.price?.map((item: any) => {
                            return ({
                                ...item,
                                locale: 'en-US',
                                amount: item?.amount
                            })
                        }),
                        meta: this._getProdDesc(_data?.receipt),
                        actions: this._getButtons(_data?.price, _data?.claimEnabled, _data?.state,_data?.type),
                        images: this._getImages(_data?.img, _data?.media, _data?.type),
                        ownership: this._getOwnershipButtons(res?.data),
                        nftProvenance: _data?.nftProvenance?.map((item: any) => {
                            return ({
                                title: item?.title,
                                profile: {
                                    userName: item?.from?.name ?? item?.to?.name ,
                                    link: item?.form?.link,
                                    tx_proof:item?.tx_proof,
                                    fromAddress:item?.from?.address,
                                    toAddress:item?.to?.address,
                                    authProofUrl: _data?.img  
                                },
                                eventOccurence: {
                                    date: moment.utc(item?.date).format('lll')
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        
                        createdBy: {
                            ..._data?.creator,
                            userId: _data?.creator?.name ?? _data?.creator?.address,
                            userName: _data?.creator?.name ?? _data?.creator?.address,
                            authProofUrl: _data?.img
                        },
                        ownedBy: _data?.owner ? {
                            ..._data?.owner,
                            userName: _data?.owner?.name ?? _data?.owner?.address,
                            userId: _data?.owner?.name ?? _data?.owner?.address,
                            authProofUrl: _data?.img
                        } : null,
                    }
                    return _found
                };
            }
        }
        catch (err) {
            getErrorMessage(err);
        }
    }

    _getProdDesc(items: any) {
        let _tempData = Array.isArray(items) && items?.filter(item => item?.value !== null && item?.key !== 'Purchase Price' && item?.key !== 'Transaction Fee' && item?.key !== 'NFT Transfer Address');

        let _formattedData = Array.isArray(_tempData) && _tempData.map(item => {
            if (item?.key === 'Purchase Date') {
                return ({
                    ...item,
                    value: moment(item?.value).format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"),
                })
            }
            else return ({
                ...item
            })
        })
        return _formattedData;

    }

    async getTransactionReceipt(txId: any, signature: any) {
        let _data = transactionDetail;
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("wallet-api");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_ASSET_DETAIL,
                    variables: {
                        input: {
                            tx_id: txId
                        },
                        auth: {
                            signature: signature?.result,
                            message: "Please sign to prove your wallet address",
                            expected_address: signature?.params[1]
                        }
                    },
                });
                log.info(`date in res`, res?.data)
                if (res) {
                    let _data = res?.data?.getMyAsset
                    let _found = {
                        // ..._data,
                        name: Array.isArray(_data?.receipt) && _data?.receipt?.find(item => item?.key === "NFT Transfer Address")?.value,
                        paymentInfo: _data?.price?.map(item => {
                            return `${item?.currency}`
                        }),
                        orderDate: moment(Array.isArray(_data?.receipt) && _data?.receipt?.find(item => item?.key === "Purchase Date")?.value).format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"),
                        // price: "$4500",
                        productTitle: _data?.title,
                        productDescription: this._getProdDesc(_data?.receipt),
                        productImg: _data?.img,
                        orderStatus: 3,
                        qrCodeLink: _data?.assetAuthProof,
                        amountBreakup: [
                            {
                                key: "Purchase Price",
                                // value: "$4500"
                                value: _data?.price?.map(item => {
                                    return `${item?.symbol + ' ' + item?.amount}`
                                })
                            },
                            // {
                            //     key: "Transaction Fee",
                            //     value: "$ 100.00"
                            // }
                        ],
                        orderReciptButtons: [
                            {
                                key: "print",
                                title: "Print",
                                disabled: true
                            },
                            {
                                key: "download",
                                title: "Download",
                                disabled: true
                            },

                        ],
                        // tx_id:txId,
                        // idx: _data?.serialNo,
                        // title: _data?.title,
                        // chainId: 1,
                        // subtitle: [_data?.subtitle, " "],
                        // serialNo: `Rare #/ ${_data?.serialNo}`,
                        // networkType: _data?.networkType,
                        // tag: _data?.tag?.toUpperCase(),
                        // category: _data?.tag?.toLowerCase(),
                        // price: _data?.price?.map((item: any) => {
                        //     return ({
                        //         ...item,
                        //         locale: 'en-US',
                        //         amount: item?.amount
                        //     })
                        // }),
                        // meta: _data?.attrs?.map((item: any) => {
                        //     return ({
                        //         ...item,
                        //         key: item?.name,
                        //         value: item?.val,
                        //         disp_type: item?.disp_type
                        //     })
                        // }),
                        // actions: this._getButtons(_data?.price, _data?.claimEnabled),
                        // images: this._getImages(_data?.img, _data?.media),
                        // ownership: this._getOwnershipButtons(res?.data),
                        // nftProvenance: _data?.nftProvenance?.map((item: any) => {
                        //     return ({
                        //         title: item?.title,
                        //         profile: {
                        //             userId: item?.from?.userId,
                        //             userName: item?.from?.name,
                        //             link: item?.form?.link
                        //         },
                        //         eventOccurence: {
                        //             date: moment.utc(item?.date).format('lll')
                        //         },
                        //         meta: {
                        //             ...item?.meta
                        //         }
                        //     })
                        // }),
                        // createdBy: {
                        //     ..._data?.creator,
                        //     userId: _data?.creator?.name,
                        //     userName: _data?.creator?.name,
                        //     authProofUrl: res?.data?.viewInIpfs
                        // },
                        // ownedBy: {
                        //     ..._data?.owner,
                        //     userName: _data?.owner?.name,
                        //     userId: _data?.owner?.name,
                        //     authProofUrl: res?.data?.viewInIpfs
                        // },
                    }
                    return _found
                };
            }

        }
        catch (err: any) {
            getErrorMessage(err);
        }
    }

    async enableResell(signature:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        console.log('enanle resell service called', signature);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REGISTER_MY_WALLET,
                    variables: {
                        auth:{
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                log.info(SERVICE_NAME, "handleLikes: ", res);
                return res?.data;
            }
        } catch (err:any) {
            getErrorMessage(err);
        }
    }
}